import  { useState } from "react";

import { useNavigate } from "react-router-dom";
import { IoIosArrowDropleft } from "react-icons/io";
import CustomButton from "../../components/CustomButton";

const ChooseAvatar = () => {
  const navigate = useNavigate();

  const avatars = [
    {
      imageUrl: "https://static.vecteezy.com/system/resources/thumbnails/027/951/137/small_2x/stylish-spectacles-guy-3d-avatar-character-illustrations-png.png",
      avatarName: "AceMark"
    },
    {
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcaU1PG8nriUudioTdXuq4YT3f9rwrNXaebQ&s",
      avatarName: "SmashLeo"
    },
    {
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvu2rqI1h9juyfQvyB9-0QfNjroSteYJWwuQ&s",
      avatarName: "AceLena"
    },
    {
      imageUrl: "https://cdni.iconscout.com/illustration/premium/thumb/female-tennis-player-illustration-download-in-svg-png-gif-file-formats--playing-girl-precision-sports-pack-games-illustrations-7589420.png",
      avatarName: "SmashTina"
    },
    {
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkfQvsle0xN8WLXkCbj3iQpnNFko5sam4FHvmEhJ3e-NFQI6tpQSZkwkCBN9aoPj8EnrU&usqp=CAU",
      avatarName: "Joe"
    },
    {
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxGeVn1-wlM1ImV4YHc89MvL1jPqSa1UOAFA&s",
      avatarName: "TopspinZara"
    },
    {
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSREDZzdKEba2tVS-QPkXK2YkIXWae-1E2cQ&s",
      avatarName: "TopspinJake"
    }
  ];
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const handleSelect = (avatar) => {
    setSelectedAvatar(avatar);
  };

  const handleSave = () => {
    if (selectedAvatar?.imageUrl) {
      navigate('/profile/edit-profile', { state: { image: selectedAvatar.imageUrl } });
    }
  };

  const onBackTo = () => {
    navigate(-1);
  };

  return (
    <div className="container mt-sm-3 mb-sm-3  p-4 choose-avtar-wrapper" >
      <div className="d-flex justify-content-between mb-3 choose-back-txt-wrapper">
        <CustomButton
          className="back-page-btn"
          onClick={onBackTo}
          buttonText={
            <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
          }
        />
        <h2 className="text-center mb-4 fs-3" style={{ fontWeight: '700' }}>Choose Avatar</h2>
      </div>
      <div className="row justify-content-center">
        {avatars.map((avatar, index) => (
          <div key={index} className="col-4 col-sm-3 col-md-2 text-center mb-4">
            <div
              onClick={() => handleSelect(avatar)}
              className="rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "80px",
                height: "80px",
                margin: "auto",
                border: selectedAvatar?.imageUrl === avatar.imageUrl ? "3px solid blue" : "2px solid #FFD700",
                cursor: "pointer",
                transition: "border 0.3s ease"
              }}
            >
              <img
                src={avatar.imageUrl}
                alt={avatar.avatarName}
                className="rounded-circle"
                style={{ width: "70px", height: "70px", objectFit: 'cover' }}
              />
            </div>
            <p className="mt-2">{avatar.avatarName}</p>
          </div>
        ))}
      </div>
      <div className="text-center mt-4">
        <button
          className="btn btn-primary w-100 w-sm-50"
          onClick={handleSave}
          disabled={!selectedAvatar?.imageUrl}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ChooseAvatar;
